import React from "react";
import { Box } from "@mui/material";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import OnboardingBranding from "./OnboardingBranding";

export default function OnboardingLayout({
    children,
    showLanguageSelector = true,
    header = null,
    rightClassName = "",
}) {
    return (
        <div className="main-div-l-r">
            {header}

            <div className="div-left-signin">
                {showLanguageSelector && (
                    <Box m={2}>
                        <LanguageSelector />
                    </Box>
                )}
                <Box className="div-left-signin__branding">
                    <OnboardingBranding />
                </Box>
            </div>

            <div className={`div-right-signin ${rightClassName}`}>
                {children}
            </div>
        </div>
    );
}
